import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';
import { FaPlug, FaUsers, FaUserShield, FaKey, FaRegCreditCard } from 'react-icons/fa';
import { HiUserGroup } from 'react-icons/hi';
import { FiBarChart2 } from 'react-icons/fi';
import { IconType } from 'react-icons';
import { useTranslation } from 'react-i18next';

interface SettingsMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const SettingsMenu: React.FC<SettingsMenuProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('dashboard');
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleNavigation = (path: string) => {
    navigate(path);
    onClose();
  };

  const menuItems: Array<{ icon: IconType; labelKey: string; path: string }> = [
    { icon: FaPlug, labelKey: 'settingsMenu.connections', path: '/settings/connections' },
    { icon: FaUsers, labelKey: 'settingsMenu.users', path: '/settings/users' },
    { icon: HiUserGroup, labelKey: 'settingsMenu.teams', path: '/settings/teams' },
    { icon: FaUserShield, labelKey: 'settingsMenu.groups', path: '/settings/groups' },
    { icon: FaKey, labelKey: 'settingsMenu.permissions', path: '/settings/permissions' },
    { icon: FiBarChart2, labelKey: 'settingsMenu.usage', path: '/settings/usage' },
    { icon: FaRegCreditCard, labelKey: 'settingsMenu.subscription', path: '/settings/subscription' }
  ];

  return (
    <div className="absolute top-full right-0 mt-2 w-80 bg-white border border-gray-200 rounded-md shadow-lg z-50 p-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-lg font-semibold text-gray-900">{t('settingsMenu.title')}</span>
        <button onClick={onClose} className="text-gray-500 hover:text-red-500 text-xl">
          <IoClose />
        </button>
      </div>

      <ul className="text-sm text-gray-700 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <li
              key={item.path}
              onClick={() => handleNavigation(item.path)}
              className="flex items-center cursor-pointer hover:text-blue-600 hover:bg-gray-50 p-2 rounded-lg transition"
            >
              <Icon className="mr-2" /> {t(item.labelKey)}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SettingsMenu;
